import ForgotPassword from '@/components/authentication/ForgotPassword';

export const Route = createFileRoute({
	component: ForgotPassword,
	validateSearch: (search: Record<string, unknown>) => {
		return {
			email: (search.email as string) || undefined,
		};
	},
});
